export const getQuery = (filters: Record<string, string>) => {
  const predicates = Object.keys(filters).map((filter) => {
    return {
      field: filter,
      value: filters[filter],
    };
  });

  if (predicates.length === 0) {
    return [];
  }

  return predicates;
};
